import { createTheme, responsiveFontSizes } from "@mui/material";



declare module '@mui/material/styles/createPalette' {
    interface Palette {
    backgroundLight: Palette['primary'];
    backgroundLight2: Palette['primary'];
    backgroundDark: Palette['primary'];
    caput: Palette['primary'];
  }
  interface PaletteOptions {
    backgroundLight?: PaletteOptions['primary'];
    backgroundLight2?: PaletteOptions['primary'];
    backgroundDark?: PaletteOptions['primary'];
    caput?: PaletteOptions['primary'];
  }
}


declare module "@mui/material/styles" {
    interface TypographyVariants {
        subtitle3: React.CSSProperties;
    }
    interface TypographyVariantsOptions {
        subtitle3?: React.CSSProperties;
    }
}


declare module "@mui/material/Typography" {
    interface TypographyPropsVariantOverrides {
        subtitle3: true;
    }
}

// Extend the default breakpoints with custom ones
// declare module '@mui/material/styles' {
//     interface BreakpointOverrides {
//         xs: true;
//         sm: true;
//         md: true;
//         lg: true;
//         xl: true;
//         xxl: true; // Add a custom "xxl" breakpoint
//     }
// }


const AppThemeConfig: any = createTheme({
    // breakpoints: {
    //     values: {
    //         // xxl:''
    //     }
    // },
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
                focusRipple: false
            },
        },
        MuiButtonGroup: {
            defaultProps: {
                disableRipple: true,
                disableFocusRipple: true
            },
        },
        MuiTab: {
            defaultProps: {
                disableRipple: true,
                focusRipple: false
            },
        },
        MuiTabs: {
            defaultProps: {},
        }
    },
    palette: {
        primary: {
            main: '#004B4C',
            light: "#35AC8C"
        },
        secondary: {
            main: "#50b588",
        },
        text: {
            primary: "#262626",
            disabled: "#bdbdbd",
            secondary: "#000000",
        },
        backgroundLight: {
            main: "#fcede2",
        },
        backgroundLight2: {
            main:"#fcf2ec",
        },
        backgroundDark: {
            main: "#fbbe68"
        },
        caput: {
            main: "#462824"
        },
    },
    typography: {
        subtitle3: {
            fontSize: "4rem",
        },
        fontFamily: ['Albert Sans'].join(""),
        button: { textTransform: 'none' },
    },
    spacing: 4,
});


export default responsiveFontSizes(AppThemeConfig)



